module.exports = __webpack_public_path__ + "static/media/adv-img3.6c19a76c.jpg";